<template>
  <div>
    <!-- Botão Processar arquivo retorno -->
    <vx-card v-if="!showResult">
      <div class="flex flex-wrap-reverse items-center mb-4">
        <input
          class="p-3 mr-4 rounded-lg cursor-pointer font-medium text-base text-primary border border-solid border-primary"
          type="file"
          ref="file"
        />
        <div
          class="p-3 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-primary border border-solid border-primary"
          @click="processFile()"
        >
          <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
          <span class="ml-2 text-base text-primary">
            Processar Arquivo Retorno
          </span>
        </div>
      </div>
    </vx-card>

    <vx-card v-if="!showResult" class="mt-3">
      <div id="data-list-list-view" class="data-list-container">
        <vs-table
          noDataText="Nenhum historico encontrado do processamento do arquivo retorno"
          class="tablePrincipal"
          ref="table"
          pagination
          search
          stripe
          :max-items="itemsPerPage"
          :data="historic"
        >
          <div
            slot="header"
            class="flex flex-wrap-reverse items-center flex-grow justify-between"
          >
            <!-- Seleção das Páginas -->
            <SelectPagination
              v-if="historic.length > 0"
              :currentPage="currentPage"
              :itemsPerPage="itemsPerPage"
              :length="historic.length"
              @update="itemsPerPage = $event"
            />
          </div>
          <template v-slot:thead>
            <vs-th sort-key="data_ocorrencia" :width="'50%'"
              >Data Ocorrência</vs-th
            >
            <vs-th :width="'50%'">Ação</vs-th>
          </template>
          <!-- Corpo -->
          <template slot-scope="{ data }">
            <tbody>
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td>{{ tr.data_ocorrencia | formatDate }}</vs-td>
                <vs-td
                  ><a
                    class="cursor-pointer hover:underline"
                    @click="loadReturn(tr.data_ocorrencia)"
                    >Visualizar Dados de Retorno</a
                  >
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>
      </div>
    </vx-card>

    <!-- Resultado do processamento -->
    <vx-card v-else>
      <div id="data-list-list-view" class="data-list-container">
        <vs-table
          noDataText="Nenhum resultado encontrado do processamento do arquivo retorno"
          class="tablePrincipal"
          ref="table"
          pagination
          :max-items="itemsPerPage"
          search
          :data="listBoletosArquivoRetorno"
        >
          <div
            slot="header"
            class="flex flex-wrap-reverse items-center flex-grow justify-between"
          >
            <!-- Botão Voltar -->
            <div
              class="p-3 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-primary border border-solid border-primary"
              @click="backListHistoric()"
            >
              <feather-icon icon="ChevronLeftIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary"> Voltar </span>
            </div>

            <!-- Seleção das Páginas -->
            <SelectPagination
              v-if="listBoletosArquivoRetorno.length > 0"
              :currentPage="currentPage"
              :itemsPerPage="itemsPerPage"
              :length="listBoletosArquivoRetorno.length"
              @update="itemsPerPage = $event"
            />
          </div>
          <template slot="thead">
            <vs-th>Nosso Número</vs-th>
            <vs-th>Associado</vs-th>
            <vs-th>Valor</vs-th>
            <vs-th>Ocorrência</vs-th>
          </template>

          <template slot-scope="{ data }">
            <tbody>
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <!-- Nosso Número -->
                <vs-td>
                  {{ tr.nosso_numero }}
                </vs-td>
                <!-- Associado -->
                <vs-td>
                  {{ tr.nome }}
                </vs-td>
                <!-- Valor -->
                <vs-td>
                  {{ tr.valor_boleto | currency }}
                </vs-td>
                <!-- Ocorrência -->
                <vs-td>
                  {{ tr.descricao_ocorrencia }}
                  <span v-if="tr.codigo_erros">
                    | Código erro: {{ tr.codigo_erros }}
                  </span>
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>
      </div>
    </vx-card>
  </div>
</template>

<script>
import SelectPagination from './../../../utils/list/header/SelectPagination';
import notify from './../../../utils/notify';
import service from './../../../services';

export default {
  data() {
    return {
      showResult: false,
      itemsPerPage: 10,
      listBoletosArquivoRetorno: [],
      isMounted: false,
      file: null,
      historic: [],
    };
  },
  methods: {
    async processFile() {
      try {
        this.$vs.loading();
        const dataOcorrencia = await this.sendFile();
        this.listBoletosArquivoRetorno = await this.loadResultProcess(
          dataOcorrencia,
        );
        this.showResult = true;
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
    sendFile() {
      return new Promise(async (resolve, reject) => {
        try {
          const formFile = new FormData();
          const getFile = await this.getFile();

          formFile.set('file', getFile.file, getFile.name);

          const result = await service.upload(
            'RetornoRemessas',
            'idEmpresa=null/idUsuario=null',
            formFile,
          );

          resolve(result);
        } catch (error) {
          reject(error);
        }
      });
    },
    loadResultProcess({ dataOcorrencia }) {
      return new Promise(async (resolve, reject) => {
        try {
          const action = `idEmpresa=null/${dataOcorrencia}`;
          const getAll = await service.getAll('RetornoRemessas', {}, action);

          if (Array.isArray(getAll.data)) {
            return resolve(getAll.data);
          }

          return reject('Falha ao listar');
        } catch (error) {
          reject(error);
        }
      });
    },
    async loadReturn(dataOcorrencia) {
      try {
        this.$vs.loading();

        dataOcorrencia = dataOcorrencia.slice(0, 10);
        this.listBoletosArquivoRetorno = await this.loadResultProcess({
          dataOcorrencia,
        });

        this.showResult = true;
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
    getFile() {
      return new Promise((resolve, reject) => {
        const fileList = this.$refs.file.files;

        if (fileList.length == 0) {
          return reject('Selecione um arquivo');
        }

        const file = fileList[0];
        const { name } = file;

        resolve({ name, file });
      });
    },
    async getHistoric() {
      try {
        this.$vs.loading();

        const action = `idEmpresa=null`;
        const result = await service.getAll('RetornoRemessas', {}, action);

        this.historic = result.data;
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
    backListHistoric() {
      this.showResult = false;
      this.$refs.table.searchx = null;
    },
  },
  components: {
    SelectPagination,
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
  },
  mounted() {
    this.isMounted = true;
    this.getHistoric();
  },
};
</script>

<style lang="scss">
#data-list-list-view {
  .vs-table--header {
    display: flex;
    flex-wrap: wrap-reverse;
    margin-left: 1.5rem;
    margin-right: 1.5rem;
    > span {
      display: flex;
      flex-grow: 1;
    }

    .vs-table--search {
      padding-top: 0;

      .vs-table--search-input {
        padding: 0.9rem 2.5rem;
        font-size: 1rem;

        & + i {
          left: 1rem;
        }

        &:focus + i {
          left: 1rem;
        }
      }
    }
  }

  .vs-table {
    border-collapse: separate;
    border-spacing: 0 1.3rem;
    padding: 0 1rem;

    tr {
      box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
      cursor: default;
      td {
        padding: 20px;
        &:first-child {
          border-top-left-radius: 0.5rem;
          border-bottom-left-radius: 0.5rem;
        }
        &:last-child {
          border-top-right-radius: 0.5rem;
          border-bottom-right-radius: 0.5rem;
        }
      }
      td.td-check {
        padding: 20px !important;
      }
    }
  }

  .vs-table--thead {
    th {
      padding-top: 0;
      padding-bottom: 0;

      .vs-table-text {
        text-transform: uppercase;
        font-weight: 600;
      }
    }
    th.td-check {
      padding: 0 15px !important;
    }
    tr {
      background: none;
      box-shadow: none;
    }
  }

  .vs-table--pagination {
    justify-content: center;
  }
}
</style>
